import React from "react";
import { Card, Container} from "reactstrap";
import BreadCrumb from "../../Components/Common/BreadCrumb";
import AGMemberList from "./AGMemberList"

const AGMember = () => {
  const breadcrumbItems = [
    { title: "AGM", link: "" },
    { title: "Members", link: "/agmember/member" },
  ];

  return (
    <React.Fragment>
      <div className="page-content">
        <Container fluid>
          <BreadCrumb items={breadcrumbItems} />
          <Card className="card_container">
            <AGMemberList />
          </Card>
        </Container>
      </div>
    </React.Fragment>
  );
};

export default AGMember;